import { Classes, Colors } from '@blueprintjs/core'
import * as React from 'react'
import { channelById } from '../../../../../../constants/Channels'
import { UprightStyle } from '../../../../../../types'
import { Listing } from '../../types'
import { formatDateTime, resolveBinPrice, formatMoneyWithListingCurrency } from '../../utils'
import { ListingProperty } from '../ListingProperty'

interface Props {
  listing: Listing
}

const styles: UprightStyle = {
  propertyRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 0 auto',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  dateRange: {
    fontStyle: 'italic',
    color: Colors.GRAY3,
    padding: '4px 0'
  }
}

export const FutureListingInfo: React.FC<Props> = props => {
  const binPrice = resolveBinPrice(props.listing.binPrice, props.listing.marketId)
  const channel = channelById(props.listing.marketId)

  return (
    <>
      <div>
        <b>{props.listing.accFullHumanReadableName || channel.humanReadableName}</b>
      </div>
      <div style={styles.dateRange} className={Classes.TEXT_SMALL}>
        Scheduled {formatDateTime(props.listing.startTime, false)}
        {props.listing.startTime && props.listing.projectedEndTime && ' – '}
        {formatDateTime(props.listing.projectedEndTime, false)}
      </div>
      <div style={styles.propertyRow}>
        <ListingProperty
          name="Start price"
          value={
            props.listing.startPrice &&
            formatMoneyWithListingCurrency(props.listing.startPrice, props.listing.currencyCode)
          }
        />
        {binPrice && (
          <ListingProperty
            name="Buy now price"
            value={formatMoneyWithListingCurrency(binPrice, props.listing.currencyCode)}
          />
        )}
        {props.listing.shippingPrice && (
          <ListingProperty
            name="Shipping price"
            value={formatMoneyWithListingCurrency(props.listing.shippingPrice, props.listing.currencyCode)}
          />
        )}
      </div>
    </>
  )
}
